
import City from 'models/City';
import District from 'models/CityDistrict';

import { Props as LayoutContainerProps } from 'components/layout/LayoutContainer';
import { Filters } from 'components/modules/public/pages/Jobs/types';

import Component from './component';

export interface Props {
    cities: City[];
    title?: string;
    layoutContainerProps?: LayoutContainerProps;

    searchParams: any;
    onChangeSearchParam: (key: string, value: any, clear?: boolean ) => void;

}

Component.defaultProps = {
    title: null,
    layoutContainerProps: {},
};

export default Component;